var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
import { html, unsafeCSS } from "lit";
import { customElement } from "lit/decorators.js";
import { TabGroup } from "../../tabs/tab-group.ts";
import styles from "./tabs.css?type=raw";
import "./heatmap/heatmap.ts";
import "./artist/artist.ts";
import "./venue/venue.ts";
import "./city/city.ts";
let GigsTabs = class GigsTabs extends TabGroup {
    constructor() {
        super(...arguments);
        this.label = "Gig charts";
        this.tabs = [
            {
                id: "month",
                label: "Year / month",
                render: () => html `<gigs-year-month-heatmap></gigs-year-month-heatmap>`,
            },
            { id: "artist", label: "Artist", render: () => html `<gigs-by-artist></gigs-by-artist>` },
            { id: "venue", label: "Venue", render: () => html `<gigs-by-venue></gigs-by-venue>` },
            { id: "city", label: "City", render: () => html `<gigs-by-city></gigs-by-city>` },
        ];
    }
    static { this.styles = [...TabGroup.styles, unsafeCSS(styles)]; }
};
GigsTabs = __decorate([
    customElement("gigs-tabs")
], GigsTabs);
export { GigsTabs };
